import { useState } from "react"
import { FacilityForm } from "@/types/facility"

export enum DialogMode {
   ACTIVATE = "activate",
   DEACTIVATE = "deactivate",
}

export type EntraDialogMode = DialogMode.ACTIVATE | DialogMode.DEACTIVATE | null

interface UseEntraActivationParams {
   updateEntraFields: (fields: Partial<FacilityForm>) => Promise<void>
   onDeactivated: () => void
}

const useEntraActivation = ({
   updateEntraFields,
   onDeactivated,
}: UseEntraActivationParams) => {
   const [entraDialogMode, setEntraDialogMode] = useState<EntraDialogMode>(null)
   const [entraActionLoading, setEntraActionLoading] = useState(false)

   const openActivateDialog = () => setEntraDialogMode(DialogMode.ACTIVATE)
   const openDeactivateDialog = () => setEntraDialogMode(DialogMode.DEACTIVATE)
   const closeEntraDialog = () => setEntraDialogMode(null)

   const confirmEntraDialog = async () => {
      setEntraDialogMode(null)
      setEntraActionLoading(true)

      try {
         if (entraDialogMode === DialogMode.ACTIVATE) {
            await updateEntraFields({ entraSsoActive: true })
         } else {
            await updateEntraFields({ entraSsoActive: false })
            onDeactivated()
         }
      } catch (error) {
         console.error("Entra SSO update failed:", error)
      } finally {
         setEntraActionLoading(false)
      }
   }

   return {
      entraDialogMode,
      entraActionLoading,
      openActivateDialog,
      openDeactivateDialog,
      closeEntraDialog,
      confirmEntraDialog,
   }
}

export default useEntraActivation
